<template>
  <div class="map-content" @click="kuangPopupVisible = false">
    <div id="map" class="map" :class="{ diff: activeIndex === '6' }">
      <template v-if="activeIndex === '6'">
        <div id="map2" class="item"></div>
        <div id="map3" class="item"></div>
      </template>
    </div>

    <div class="back" @click="$router.back()">
      <span class="iconfont icon-jiantou_liebiaoxiangzuo_o"></span>
      <span class="label">返回</span>
    </div>

    <div class="version-list">
      <el-dropdown trigger="click">
        <span class="label">{{ currentVersionName }}</span>
        <span class="iconfont icon-tihuan"></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item, index) of versionList" :key="index" @click.native="changeVersion(index)">
            <i v-if="currentVersionIndex === index" class="el-icon-check"></i>
            <i v-else class="el-icon-check" style="visibility: hidden;"></i>
            {{ item.version + '-' + (item.uploadname || '未知日期') }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div class="version-list other" v-if="activeIndex === '6'">
      <el-dropdown trigger="click">
        <span class="label">{{ otherVersionName }}</span>
        <span class="iconfont icon-tihuan"></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item, index) of versionList" :key="index" @click.native="changeVersion2(index)">
            <i v-if="otherVersionIndex === index" class="el-icon-check"></i>
            <i v-else class="el-icon-check" style="visibility: hidden;"></i>
            {{ item.version + '-' + (item.uploadname || '未知日期') }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div class="version-list diff" @click="showDiffDialog" v-if="activeIndex === '6'">
      <span class="label">查看数据对比</span>
    </div>

    <div class="tools">
      <div class="tool-item" :class="{ active: activeIndex === '4' }" @click="onAction('4')">
        <span class="iconfont icon-shouzhi"></span>
        <span class="label">点选</span>
      </div>
      <div class="tool-item" :class="{ active: activeIndex === '5' }" @click.stop="onAction('5')">
        <span class="iconfont icon-kuangxuan"></span>
        <span class="label">框选</span>
      </div>
      <div class="tool-item" :class="{ active: activeIndex === '0' }" @click="onAction('0')">
        <span class="iconfont icon-mianji"></span>
        <span class="label">测面积</span>
      </div>
      <div class="tool-item" :class="{ active: activeIndex === '1' }" @click="onAction('1')">
        <span class="iconfont icon-juli2"></span>
        <span class="label">测距离</span>
      </div>
      <div class="tool-item" :class="{ active: activeIndex === '6' }" @click="onAction('6')">
        <span class="iconfont icon-a-duibi1"></span>
        <span class="label">对比</span>
      </div>
      <!-- <div class="tool-item" :class="{ active: activeIndex === '2' }" @click="onAction('2')">
        <span class="iconfont icon-jiaodu"></span>
        <span class="label">测角度</span>
      </div>
      <div class="tool-item" :class="{ active: activeIndex === '3' }" @click="onAction('3')">
        <span class="iconfont icon-jingweidu"></span>
        <span class="label">测坐标</span>
      </div> -->
    </div>
    <div class="kuang-popup" v-if="kuangPopupVisible">
      <div class="item" :class="{ active: kuangPopopIndex === '0' }" @click="onAction5('0')">
        <img src="@/assets/img/measure/icon1.png" />
        <span class="label">矩形</span>
      </div>
      <div class="item" :class="{ active: kuangPopopIndex === '1' }" @click="onAction5('1')">
        <img src="@/assets/img/measure/icon2.png" />
        <span class="label">圆形</span>
      </div>
      <div class="item" :class="{ active: kuangPopopIndex === '2' }" @click="onAction5('2')">
        <img src="@/assets/img/measure/icon3.png">
        <span class="label">多边形</span>
      </div>
    </div>

    <Compare :dialogVisible.sync="dialogVisible" @closeDialog="closeDialog" :currentVersion="currentVersion"
      :otherVersion="otherVersion" :currentVersionName="currentVersionName" :otherVersionName="otherVersionName">
    </Compare>

    <!-- <div ref="popup" class="popup">
      <div class="header" :class="{ center: popupData.type === '3' }">
        <span>{{ popupData.title }}</span>
      </div>
      <div class="info center" v-if="popupData.type === '0'">
        <span>暂无数据</span>
      </div>
      <div class="info" v-if="popupData.type === '1'">
        <span>实体名：</span>
        <span>{{ popupData.objectName }}</span>
      </div>
      <div class="info" v-if="popupData.type === '2'">
        <span>面积：</span>
        <span>{{ popupData.area }}㎡</span>
      </div>
    </div> -->

    <div ref="popup" class="zhitu-popup">
      <div class="header" :class="{ center: popupData.type === '3' }">
        <span>{{ popupData.title }}</span>
      </div>
      <div class="info center" v-if="popupData.type === '0'">
        <span>暂无数据</span>
      </div>
      <div class="info" v-if="popupData.type === '1'">
        <span>实体名：</span>
        <span>{{ popupData.objectName }}</span>
      </div>
      <div class="info" v-if="popupData.type === '2'">
        <span>面积：</span>
        <span>{{ popupData.area }}㎡</span>
      </div>
      <div class="table" v-if="popupData.type === '4'">
        <table>
          <thead>
            <tr>
              <th>名称</th>
              <th>数量/面积</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="[key, value] of popupData.tableData" :key="key">
              <td>{{ key }}</td>
              <td>{{ value.value }}{{ value.isArea ? '㎡' : '' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
// import vjmap from 'vjmap'
// import 'vjmap/dist/vjmap.min.css'
import { vjEnv } from '@/utils/config'
import Compare from './Compare'
export default {
  name: 'Measure',
  components: {
    Compare
  },
  data () {
    return {
      cadAreaNameList: [],
      activeIndex: '',
      isDrawing: false,
      versionList: [],
      currentVersionIndex: 0,
      otherVersionIndex: 1,
      dialogVisible: false,
      featureIdObjectIdMap: {},
      entityIdFeatureIdMap: {},
      curHoverIds: null,
      popupData: {},
      kuangPopupVisible: false,
      kuangPopopIndex: null
    }
  },
  computed: {
    cadId () {
      return this.$route.query.cadId
    },
    currentVersion () {
      const data = this.versionList[this.currentVersionIndex]
      return data ? data.version : ''
    },
    otherVersion () {
      const data = this.versionList[this.otherVersionIndex]
      return data ? data.version : ''
    },
    currentVersionName () {
      const data = this.versionList[this.currentVersionIndex]
      return data ? (data.version + '-' + (data.uploadname || '未知日期')) : ''
    },
    otherVersionName () {
      const data = this.versionList[this.otherVersionIndex]
      return data ? (data.version + '-' + (data.uploadname || '未知日期')) : ''
    }
  },
  watch: {
    currentVersion (val) {
      this.$store.commit('setCadVersion', val)
    }
  },
  created () {
    this._popup = null
    this._overlayers = []
    // do something
    this.loadDict()
    this.$event.$on('setAssetsActive', entityIds => {
      if (entityIds) {
        let ss = []
        for (const entityId of entityIds) {
          const ids = this.entityIdFeatureIdMap[entityId]
          ss = ss.concat([...ids])
        }
        const curIds = new Set(ss)
        this.highlightEntitys(curIds)
      } else {
        this.highlightEntity(null)
      }
    })

    this.$event.$on('setAreasActive', objectIds => {
      if (objectIds) {
        const entityIds = objectIds.split(',')
        let ss = []
        for (const entityId of entityIds) {
          const ids = this.entityIdFeatureIdMap[entityId]
          ss = ss.concat([...ids])
        }
        const curIds = new Set(ss)
        this.highlightEntitys(curIds)
      } else {
        this.highlightEntity(null)
      }
    })
  },
  beforeDestroy () {
    this.$event.$off('setAssetsActive')
    this.$event.$off('setAreasActive')
    // this.destroyAnimateLayers()
    this.clearOverlayers()
    this._map && this._map.remove()
    this._map2 && this._map2.remove()
  },
  mounted () {
    this.$nextTick(async () => {
      await this.initService()
      if (this.$route.query.versionIndex) {
        this.currentVersionIndex = Number(this.$route.query.versionIndex)
      }
      await this.initMap()
    })
  },
  methods: {
    clearOverlayers () {
      if (this._overlayers && this._overlayers.length) {
        this._overlayers.forEach(overlayer => overlayer.remove())
        this._overlayers = []
      }
    },
    destroyAnimateLayers () {
      if (this._animateLayers && this._animateLayers.length) {
        this._animateLayers.forEach(layer => layer.remove())
        this._animateLayers = []
      }
    },
    loadDict () {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'cadAreaName' }).then(res => {
        this.cadAreaNameList = res.cadAreaName || []
      })
    },
    async changeVersion (index) {
      this.currentVersionIndex = index
      if (this.activeIndex === '6') {
        this.clearOverlayers()
        this._cancelSyncCb && this._cancelSyncCb()
        this._map && this._map.remove()
        this._map2 && this._map2.remove()
        await this.initMap('map2', this.currentVersion)
        await this.initMap('map3', this.otherVersion)
        this.compareDiff()
      } else {
        this.activeIndex = ''
        this._map && this._map.remove()
        this.initMap()
      }
    },
    async changeVersion2 (index) {
      this.otherVersionIndex = index
      this.clearOverlayers()
      this._cancelSyncCb && this._cancelSyncCb()
      this._map && this._map.remove()
      this._map2 && this._map2.remove()
      await this.initMap('map2', this.currentVersion)
      await this.initMap('map3', this.otherVersion)
      this.compareDiff()
    },
    async loadVersion () {
      const data = await this._svc.listMaps(this.cadId, '*')
      this.versionList = data.reverse()
    },
    // 通过图层名称来查找图层id
    getLayerIdByName (name) {
      return this._svc.getMapLayers().findIndex(layer => layer.name === name)
    },
    conditionLayers (layers, inputIsIndex) {
      if (!Array.isArray(layers)) layers = [layers]// 先转成数组，再统一用数组去算吧
      if (!inputIsIndex) {
        // 如果输入的不是图层索引，是图层名称，则需要转成图层索引
        layers = layers.map(layer => this.getLayerIdByName(layer)) // 把图层名称转为图层索引，在矢量瓦片中图层是用索引来表示的
      }
      return [
        'match',
        ['get', 'layer'],
        layers,
        true,
        false
      ]
    },
    switchLayers (onLayers) {
      // 获取之前的默认的矢量图层样式，然后在当前样式中，对矢量图层的数据进行图层进行过滤
      const style = this._map.getStyle()
      const vectorStyle = this._svc.vectorStyle()
      const vectorLayerIds = vectorStyle.layers.map(layer => layer.id)
      const filter = this.conditionLayers(onLayers, true)
      for (let i = 0; i < style.layers.length; i++) {
        if (vectorLayerIds.includes(style.layers[i].id)) {
          style.layers[i].filter = filter // 设置过滤条件
        }
      }
      this._map.setStyle(style)
    },
    async onAction (activeIndex) {
      if (this.activeIndex === '6' && activeIndex !== '6') {
        this.resetSelection()
        this.activeIndex = activeIndex
        await this.initMap()
      } else {
        this.resetSelection()
        this.activeIndex = activeIndex
      }
      this.$event.$emit('toolChange', activeIndex)
      switch (activeIndex) {
        case '0': // 测面积
          this.measureAreaLoop()
          break
        case '1': // 测距离
          this.measureDistLoop()
          break
        case '2': // 测角度
          this.measureAngleLoop()
          break
        case '3': // 测坐标
          this.measureCoordinateLoop()
          break
        case '4': // 点选
          this.clickHighlight()
          break
        case '5': // 框选
          this.kuangPopupVisible = true
          // this.measureCoordinateLoop()
          break
        // case '5-1': // 矩形
        //   // eslint-disable-next-line no-case-declarations
        //   const ss = await this.selectFeature(false)
        //   // this.measureCoordinateLoop()
        //   break
        // case '5-2': // 圆形
        //   // this.measureCoordinateLoop()
        //   break
        // case '5-3': // 多边形
        //   // this.measureCoordinateLoop()
        //   break
        case '6': // 对比
          if (this.versionList.length === 1) {
            this.currentVersionIndex = 0
            this.otherVersionIndex = 0
          } else {
            this.currentVersionIndex = 0
            this.otherVersionIndex = 1
          }
          this._map && this._map.remove()
          this.$nextTick(async () => {
            await this.initMap('map2', this.currentVersion)
            await this.initMap('map3', this.otherVersion)
            this.compareDiff()
          })
          break
        default:
          break
      }
    },
    async onAction5 (index) {
      this.kuangPopopIndex = index
      switch (index) {
        case '0':
          // eslint-disable-next-line no-case-declarations
          await this.selectFeature('0')
          break
        case '1':
          await this.selectFeature('1')
          break
        case '2':
          await this.selectFeature('2')
          break
        default:
          break
      }
      // if (this.isDrawing && index !== '1') {
      //   this.onAction5(index)
      // }
    },
    async selectFeature (type) {
      this.isDrawing = true
      let drawResult = null
      const menuItems = [
        {
          label: '确认',
          onClick: () => {
            // 给地图发送Enter键消息即可取消，模拟按Enter键
            this._map.fire('keyup', { keyCode: 13 })
            this.setPopupText('')
          }
        }, {
          label: '取消',
          onClick: () => {
            // 给地图发送ESC键消息即可取消，模拟按ESC键
            this._map.fire('keyup', { keyCode: 27 })
            this.setPopupText('')
          }
        }, {
          label: '结束框选',
          onClick: () => {
            // 给地图发送ESC键消息即可取消，模拟按ESC键
            this.resetSelection()
          }
        }
      ]
      if (type === '2') {
        menuItems.splice(2, 0, {
          label: '删除上一个点',
          onClick: () => {
            // 给地图发送退格键Backspace消息即可删除上一个点，模拟按Backspace键
            this._map.fire('keyup', { keyCode: 8 })
          }
        })
      }
      const contextMenuCallback = e => {
        new vjmap.ContextMenu({
          event: e.event.originalEvent,
          theme: 'dark', // light
          width: '250px',
          items: menuItems
        })
      }
      if (type === '0') {
        drawResult = await vjmap.Draw.actionDrawRectangle(this._map, {
          contextMenu: contextMenuCallback
        })
      }
      if (type === '1') {
        drawResult = await vjmap.Draw.actionDrawCircle(this._map, {
          contextMenu: contextMenuCallback
        })
      }
      if (type === '2') {
        drawResult = await vjmap.Draw.actionDrawPolygon(this._map, {
          contextMenu: contextMenuCallback
        })
      }
      if (drawResult.cancel) {
        this.activeIndex = ''
        return // 取消操作
      }
      this.clearOverlayers() // 这一步是下一次圆形框选可能不触发click清空当前，手动清除用
      const feature = drawResult.features[0]
      const polygon = new vjmap.Polygon({
        data: feature.geometry.coordinates[0],
        fillColor: 'yellow',
        fillOpacity: 0.1,
        fillOutlineColor: '#f00'
      })
      polygon.addTo(this._map)
      this._overlayers.push(polygon)
      // const co = this._map.fromLngLat(drawRect.features[0].geometry.coordinates[0])
      const bounds = this._map.fromLngLat(drawResult.features[0].geometry.coordinates[0]).map(pt => pt.toArray())
      const loadingInstance = this.$loading({ text: '查询中', background: 'rgba(0, 0, 0, 0.8)' })
      const query = await this._svc.conditionQueryFeature({
        condition: '', // 只需要写sql语句where后面的条件内容,字段内容请参考文档"服务端条件查询和表达式查询"
        bounds: bounds, // 查找此范围内的实体
        fields: 'id,objectid,area,isclosed,geojson',
        includegeom: true, // 是否返回几何数据,为了性能问题，realgeom为false时，如果返回条数大于1.只会返回每个实体的外包矩形，如果条数为1的话，会返回此实体的真实geojson；realgeom为true时每条都会返回实体的geojson
        realgeom: true,
        isContains: false, // 矩形包含才行,false是相交关系
        beginpos: 0, // 记录开始位置
        limit: 50000 // 每次查5万条
      })
      loadingInstance.close()
      if (query.result && query.result.length) {
        let ss = []
        const entityIds = new Set()
        // const entityMap = new Map()
        const areaMap = new Map()
        const entityTjMap = new Map()
        query.result.forEach(item => {
          const objectId = this.featureIdObjectIdMap[item.id]
          const entityId = this.getEntityObjectId(objectId)
          entityIds.add(entityId)
          if (item.isclosed === 1 && item.area > 0 && !item.objectid.includes('#')) {
            areaMap.set(entityId, item)
          }
        })
        for (const entityId of entityIds) {
          const ids = this.entityIdFeatureIdMap[entityId]
          ss = ss.concat([...ids])
          const entity = this._entitys.get(entityId)
          if (!entity) { // 如果找不到实体，则跳过
            continue
          }
          if (entity && entity.area > 0 && entity.isclosed === 1) { // 如果是封闭的区域，则统计面积
            const layername = entity.layername
            if (this.cadAreaNameList.some(item => layername.includes(item.dicValue))) { // 只有字典中区域才计算在内
              let currentArea = 0
              try {
                const currentPolygon = this._map.fromLngLat(areaMap.get(entityId).geom.geometries[0].coordinates).map(pt => pt.toArray())
                const polygons = vjmap.createObjectPolygonUtil().intersection(bounds, currentPolygon)
                const points = polygons[0].map(item => {
                  return { x: item[0], y: item[1] }
                })
                currentArea = vjmap.calcPolygonArea(points)
              } catch (error) {
                currentArea = entity.area
              }
              if (entityTjMap.has(layername)) {
                const data = entityTjMap.get(layername)
                data.value = parseFloat((data.value + currentArea).toFixed(2))
              } else {
                entityTjMap.set(layername, {
                  isArea: true,
                  value: parseFloat((currentArea).toFixed(2))
                })
              }
            }
          } else { // 实体
            const chineseRegex = /[\u4e00-\u9fff]/
            if (chineseRegex.test(entity.blockname)) { // 排除非中文的
              const name = entity.blockname
              if (entityTjMap.has(name)) {
                const data = entityTjMap.get(name)
                data.value = data.value + 1
              } else {
                entityTjMap.set(name, {
                  isArea: false,
                  value: 1
                })
              }
            }
          }
        }
        // 统计信息 begin
        // const entityTjMap = new Map()
        // const layers = this._svc.getMapLayers()
        // for (const [entityId, entity] of entityMap.entries()) {
        //   if (entity.length === 1) {
        //     if (entity[0].isclosed === 1 && entity[0].area > 0) { // 一个的情况只考虑面积的实体
        //       const name = layers[entity[0].layerindex].name
        //       if (this.cadAreaNameList.some(item => name.includes(item.dicValue))) {
        //         console.log('面积的entity', entity)
        //         let currentArea = 0
        //         try {
        //           const currentPolygon = this._map.fromLngLat(entity[0].geom.geometries[0].coordinates).map(pt => pt.toArray())
        //           const polygons = vjmap.createObjectPolygonUtil().intersection(bounds, currentPolygon)
        //           const points = polygons[0].map(item => {
        //             return { x: item[0], y: item[1] }
        //           })
        //           currentArea = vjmap.calcPolygonArea(points)
        //           console.log('相交面积', currentArea)
        //         } catch (error) {
        //           console.log('整个面积', currentArea)
        //           currentArea = entity[0].area
        //         }
        //         if (entityTjMap.has(name)) {
        //           const data = entityTjMap.get(name)
        //           data.value = parseFloat((data.value + currentArea).toFixed(2))
        //         } else {
        //           entityTjMap.set(name, {
        //             isArea: true,
        //             value: parseFloat((currentArea).toFixed(2))
        //           })
        //         }
        //       }
        //     }
        //   } else {
        //     const name = this.entityIdFeatureNameMap[entityId] // 用于解决查询实体名
        //     if (!name) {
        //       this.$message({ type: 'info', message: '可能存在没有名字的实体' })
        //     }
        //     if (entityTjMap.has(name)) {
        //       const data = entityTjMap.get(name)
        //       data.value = data.value + 1
        //     } else {
        //       entityTjMap.set(name, {
        //         isArea: false,
        //         value: 1
        //       })
        //     }
        //   }
        // }
        this.popupData = {
          type: '4',
          title: '统计信息',
          tableData: entityTjMap
        }
        if (!entityTjMap.size) {
          this.popupData.type = '0'
        }
        this._popup = new vjmap.Popup({
          className: 'measure-popup',
          closeOnClick: false,
          closeButton: false
        }).setDOMContent(this.$refs.popup)
          .setLngLat(drawResult.features[0].geometry.coordinates[0][0])
          .addTo(this._map)
        // 统计信息 end
        const curIds = new Set(ss)
        this.highlightEntitys(curIds)
      } else {
        this.popupData = {
          type: '0',
          title: '统计信息'
        }
        this._popup = new vjmap.Popup({
          className: 'measure-popup',
          closeOnClick: false,
          closeButton: false
        }).setDOMContent(this.$refs.popup)
          .setLngLat(drawResult.features[0].geometry.coordinates[0][0])
          .addTo(this._map)
      }
      setTimeout(() => {
        if (this.isDrawing) {
          this.selectFeature(type)
        }
      }, 100)
    },
    setPopupText (text) {
      if (text) {
        if (!this._popup) {
          this._popup = new vjmap.Popup({
            className: 'custom-popup',
            closeOnClick: false,
            closeButton: false
          })
            .setHTML(text)
            .setMaxWidth('500px')
            .trackPointer()
            .addTo(this._map)
        } else {
          this._popup.setHTML(text)
        }
      } else {
        // 如果为空时，则删除popup
        if (this._popup) {
          this._popup.setLngLat([0, 0]) // 取消trackPointer
          this._popup.remove()
          this._popup = null
        }
      }
    },
    // 引线标记
    createLeaderMarker (lnglat, content) {
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.position = 'absolute'

      const img = document.createElement('div')
      img.style.backgroundImage =
        'url("data:image/png;base64,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")'
      img.style.backgroundRepeat = 'no-repeat'
      img.style.height = '37px'
      img.style.width = '100px'
      img.style.position = 'absolute'
      img.style.left = '-3px'
      img.style.bottom = '-3px'
      img.style.right = '0px'
      el.appendChild(img)

      const panel = document.createElement('div')
      panel.style.height = '50px'
      panel.style.width = '350px'
      panel.style.position = 'absolute'
      panel.style.left = '97px'
      panel.style.top = '-60px'
      panel.style.border = 'solid 1px #8E0EFF'
      panel.style.background = 'linear-gradient(#00ffff, #00ffff) left top,  linear-gradient(#00ffff, #00ffff) left top,     linear-gradient(#00ffff, #00ffff) right bottom,    linear-gradient(#00ffff, #00ffff) right bottom'
      panel.style.backgroundRepeat = 'no-repeat'
      panel.style.backgroundColor = 'rgba(87,255,255, 0.3)'
      panel.style.backgroundSize = '1px 6px, 6px 1px'
      panel.style.fontSize = '18px'
      panel.style.color = '#ffffff'
      panel.innerHTML = `<div style='margin: 15px 5px 15px 5px'>${content}</div>`
      el.appendChild(panel)

      // Add markers to the map.
      const marker = new vjmap.Marker({
        element: el,
        anchor: 'bottom-left'
      })
      marker.setLngLat(lnglat)
        .addTo(this._map)
      return marker
    },
    // 给加个点加个测量的结果值
    addMarkersToCoord (coordinates) {
      let markerTexts = []
      const co = this._map.fromLngLat(coordinates)
      const content = `X: ${co.x.toFixed(2)}, Y: ${co.y.toFixed(2)}`
      const marker = this.createLeaderMarker(coordinates, content)
      markerTexts.push(marker)

      // 给第一个点加一个marker用来删除
      const deletePng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAbNJREFUWEftlrFOAkEQhv9Z4XgJOCrlTgp5ABOhMBoTCws7EzUaeAx5A0sDiYmFxpLGaAkU2KqFArHi4CU4cMccAQN6HHcIwZi7cnd25tt/5maHsOCPFhwfPoAnBarhQFIIccjAkV3qCMhKKct6q1tym1pPAHVVOWMg6+ScgKuYYR7PBaCmKmw5XgLiy4b5NhzkXVVWP4BXa00zTNcXc21oOR4AjAswaX9M2n4u1yLBIoiSbmV0Zcdc0pqd1HdbWwUWDuDqRjMy8lQDM4o54sYRoJcKq6qHclePKnuScQ0pd/RWt2ztVyOhLUFckIwTvWneDiLYnXdVA18O+r/dcNXXIsozCGsMzuhGJ98DUINpAuUAqmhGe33k/JjiG9g4K2ADUFdDOQan7QAIlI8Z7YwP4CvgK/C/FahFlQcwtm0bEeNFa5qJuSpgdT2AzkFyU290H3udMBzYgBD3gnAQa5iFuQJ4eZB6A8ovW/ETgARLmfIyaPZVSZIQRTBdas326Thwx7fAzRA6SREB2l0x2ndTAfTnwH0CrGk4PinY6D5VQHyhNcwbp3N/eyDxduPprH0FPgHEyH4wGIHUYwAAAABJRU5ErkJggg=='
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.backgroundImage =
        `url(${deletePng})`
      el.style.width = '20px'
      el.style.height = '20px'
      el.style.backgroundSize = '100%'
      el.style.cursor = 'pointer'

      el.addEventListener('click', function (e) {
        markerTexts.forEach(m => m.remove())
        markerTexts = []
      })
      // Add markers to the map.
      const deleteMarker = new vjmap.Marker({
        element: el,
        anchor: 'right'
      })
      deleteMarker.setLngLat(coordinates)
        .setOffset([-5, 0])
        .addTo(this._map)
      markerTexts.push(deleteMarker)
    },
    // 测量坐标循环，直至按ESC键取消
    async measureCoordinateLoop () {
      while (true) {
        const res = await this.measureCoordinate()
        if (res.exit === true) break
      }
    },
    // 测量坐标
    async measureCoordinate () {
      this.isDrawing = false
      const point = await vjmap.Draw.actionDrawPoint(this._map, {
        api: {
          getSnapFeatures: {} // 要捕捉的数据项在后面，通过属性features赋值
        },
        updatecoordinate: (e) => {
          if (!e.lnglat) return
          this.isDrawing = true
          const co = this._map.fromLngLat(e.lnglat)
          const html = `当前坐标:<span style="color: #ff0000"> ${co.x.toFixed(2)}, ${co.y.toFixed(2)}</span>`
          this.setPopupText(html)
        },
        contextMenu: (e) => {
          new vjmap.ContextMenu({
            event: e.event.originalEvent,
            theme: 'dark', // light
            width: '250px',
            items: [
              {
                label: '确认',
                onClick: () => {
                  // 给地图发送Enter键消息即可取消，模拟按Enter键
                  this._map.fire('keyup', { keyCode: 13 })
                  this.setPopupText('')
                }
              },
              {
                label: '取消',
                onClick: () => {
                  // 给地图发送ESC键消息即可取消，模拟按ESC键
                  this._map.fire('keyup', { keyCode: 27 })
                  this.setPopupText('')
                }
              },
              {
                label: '结束测坐标',
                onClick: () => {
                  // 给地图发送ESC键消息即可取消，模拟按ESC键
                  this._map.fire('keyup', { keyCode: 27 })
                  this.isDrawing = false
                  this.setPopupText('')
                }
              }
            ]
          })
        }
      })
      if (point.cancel) {
        this.setPopupText('')
        return {
          cancel: true,
          exit: this.isDrawing === false
        }// 取消操作
      }

      this.addMarkersToCoord(point.features[0].geometry.coordinates)
      return {
        point
      }
    },
    // 得到角度值
    getAngle (coordinates) {
      const points = this._map.fromLngLat(coordinates)
      if (points.length < 3) return { angle: 0.0 }
      const angle1 = points[0].angleTo(points[1])
      const angle2 = points[2].angleTo(points[1])
      const angle = angle1 - angle2
      let deg = vjmap.radiansToDegrees(angle)// 弧度转角度
      let dir = true
      if (deg < 0) {
        deg = -deg
        dir = !dir
      }
      if (deg > 180) {
        deg = 360 - deg
        dir = !dir
      }
      let startAngle = !dir ? vjmap.radiansToDegrees(angle1) : vjmap.radiansToDegrees(angle2)
      let endAngle = dir ? vjmap.radiansToDegrees(angle1) : vjmap.radiansToDegrees(angle2)
      startAngle = startAngle < 0 ? 360 + startAngle : startAngle
      endAngle = endAngle < 0 ? 360 + endAngle : endAngle
      if (endAngle < startAngle) {
        endAngle += 360
      }
      return {
        angle: deg.toFixed(2) + '°',
        dir,
        startAngle,
        endAngle
      }
    },
    // 给加个测量的结果值
    addMarkersToAngle (coordinates, color, sourceId) {
      if (coordinates.length < 3) return
      let markerTexts = []
      const points = this._map.fromLngLat(coordinates)
      // const textPoint = coordinates[1]
      const ang = this.getAngle(coordinates)
      // 绘制注记圆弧
      const cirleArcPath = vjmap.getCirclePolygonCoordinates(
        points[1],
        points[1].distanceTo(points[0]) / 4.0, 36,
        ang.startAngle, ang.endAngle, false)
      const path = new vjmap.Polyline({
        data: this._map.toLngLat(cirleArcPath),
        lineColor: color,
        lineWidth: 2
      })
      path.addTo(this._map)
      markerTexts.push(path)

      const arcPoints = path.getData().features[0].geometry.coordinates
      const arcMid = arcPoints[Math.ceil(arcPoints.length / 2)]// 取中点
      let textAngle = vjmap.radiansToDegrees(this._map.fromLngLat(arcMid).angleTo(points[1])) + 90
      if (textAngle > 90) textAngle += 180
      else if (textAngle > 270) textAngle -= 180
      const text = new vjmap.Text({
        text: ang.angle,
        anchor: 'center',
        rotation: textAngle,
        offset: [0, 0], // x,y 方向像素偏移量
        style: { // 自定义样式
          cursor: 'pointer',
          opacity: 0.8,
          padding: '6px',
          'border-radius': '12px',
          'background-color': color,
          'border-width': 0,
          'box-shadow': '0px 2px 6px 0px rgba(97,113,166,0.2)',
          'text-align': 'center',
          'font-size': '14px',
          color: `#${color.substr(1).split('').map(c => (15 - parseInt(c, 16)).toString(16)).join('')}`
        }
      })
      text.setLngLat(arcMid).addTo(this._map)
      markerTexts.push(text)
      // 给第一个点加一个marker用来删除
      const deletePng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAbNJREFUWEftlrFOAkEQhv9Z4XgJOCrlTgp5ABOhMBoTCws7EzUaeAx5A0sDiYmFxpLGaAkU2KqFArHi4CU4cMccAQN6HHcIwZi7cnd25tt/5maHsOCPFhwfPoAnBarhQFIIccjAkV3qCMhKKct6q1tym1pPAHVVOWMg6+ScgKuYYR7PBaCmKmw5XgLiy4b5NhzkXVVWP4BXa00zTNcXc21oOR4AjAswaX9M2n4u1yLBIoiSbmV0Zcdc0pqd1HdbWwUWDuDqRjMy8lQDM4o54sYRoJcKq6qHclePKnuScQ0pd/RWt2ztVyOhLUFckIwTvWneDiLYnXdVA18O+r/dcNXXIsozCGsMzuhGJ98DUINpAuUAqmhGe33k/JjiG9g4K2ADUFdDOQan7QAIlI8Z7YwP4CvgK/C/FahFlQcwtm0bEeNFa5qJuSpgdT2AzkFyU290H3udMBzYgBD3gnAQa5iFuQJ4eZB6A8ovW/ETgARLmfIyaPZVSZIQRTBdas326Thwx7fAzRA6SREB2l0x2ndTAfTnwH0CrGk4PinY6D5VQHyhNcwbp3N/eyDxduPprH0FPgHEyH4wGIHUYwAAAABJRU5ErkJggg=='
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.backgroundImage =
        `url(${deletePng})`
      el.style.width = '20px'
      el.style.height = '20px'
      el.style.backgroundSize = '100%'
      el.style.cursor = 'pointer'

      el.addEventListener('click', (e) => {
        this._map.removeSourceEx(sourceId) // 删除绘制的线
        markerTexts.forEach(m => m.remove())
        markerTexts = []
      })
      // Add markers to the map.
      const deleteMarker = new vjmap.Marker({
        element: el,
        anchor: 'right'
      })
      deleteMarker.setLngLat(coordinates[1])
        .setOffset([-5, 0])
        .addTo(this._map)
      markerTexts.push(deleteMarker)
    },
    async measureAngleLoop () {
      while (true) {
        const res = await this.measureAngle()
        if (res.exit === true) break
      }
    },
    // 测量角度
    async measureAngle () {
      this.isDrawing = false
      const line = await vjmap.Draw.actionDrawLineSting(this._map, {
        pointCount: 3, // 只需三个点，绘制完三个点后，自动结束
        api: {
          getSnapFeatures: {} // 要捕捉的数据项在后面，通过属性features赋值
        },
        updatecoordinate: (e) => {
          if (!e.lnglat) return
          this.isDrawing = true
          const co = this._map.fromLngLat(e.feature.coordinates[e.feature.coordinates.length - 1])
          let html = `当前坐标:<span style="color: #ff0000"> ${co.x.toFixed(2)}, ${co.y.toFixed(2)}</span>`
          if (e.feature.coordinates.length === 1) {
            html += '<br/>请指定要测量的第一点的坐标位置'
          } else {
            // const len = e.feature.coordinates.length
            html += '<br/>按Alt键取捕捉; Ctrl键启用正交; 退格键删除上一个点'
            html += `<br/>当前角度: <span style="color: #ff0000">${this.getAngle(e.feature.coordinates).angle}</span>`
          }
          this.setPopupText(html)
        },
        contextMenu: (e) => {
          new vjmap.ContextMenu({
            event: e.event.originalEvent,
            theme: 'dark', // light
            width: '250px',
            items: [
              {
                label: '确认',
                onClick: () => {
                  // 给地图发送Enter键消息即可取消，模拟按Enter键
                  this._map.fire('keyup', { keyCode: 13 })
                  this.setPopupText('')
                }
              },
              {
                label: '取消',
                onClick: () => {
                  // 给地图发送ESC键消息即可取消，模拟按ESC键
                  this._map.fire('keyup', { keyCode: 27 })
                  this.setPopupText('')
                }
              }, {
                label: '删除上一个点',
                onClick: () => {
                  // 给地图发送退格键Backspace消息即可删除上一个点，模拟按Backspace键
                  this._map.fire('keyup', { keyCode: 8 })
                }
              }, {
                label: '结束测角度',
                onClick: () => {
                  // 给地图发送ESC键消息即可取消，模拟按ESC键
                  this._map.fire('keyup', { keyCode: 27 })
                  this.isDrawing = false
                  this.setPopupText('')
                }
              }
            ]
          })
        }
      })
      if (line.cancel) {
        this.setPopupText('')
        return {
          cancel: true,
          exit: this.isDrawing === false // 如果还没有绘制，就取消的话，就结束测距
        }// 取消操作
      }

      const color = vjmap.randomColor()
      const polyline = new vjmap.Polyline({
        data: line.features[0].geometry.coordinates,
        lineColor: color,
        lineWidth: 2
      })
      polyline.addTo(this._map)
      this.addMarkersToAngle(line.features[0].geometry.coordinates, color, polyline.sourceId)
      return {
        polyline
      }
    },
    sleep (tm) {
      return new Promise(resolve => setTimeout(resolve, tm))
    },
    async measureAreaLoop () {
      while (true) {
        const res = await this.measureArea()
        if (res.exit === true) break
      }
    },
    async measureArea () {
      this.isDrawing = false
      await this.sleep(500) // 防止双击结束时误多点了几个点被当前下一次的起点了
      const poly = await vjmap.Draw.actionDrawPolygon(this._map, {
        api: {
          getSnapFeatures: {} // 要捕捉的数据项在后面，通过属性features赋值
        },
        updatecoordinate: (e) => {
          if (!e.lnglat) return
          this.isDrawing = true
          const co = this._map.fromLngLat(e.feature.coordinates[0][e.feature.coordinates.length - 1])
          let html = `当前坐标:<span style="color: #ff0000"> ${co.x.toFixed(2)}, ${co.y.toFixed(2)}</span>`
          if (e.feature.coordinates[0].length === 1) {
            html += '<br/>请指定要测量的第一点的坐标位置'
          } else {
            html += '<br/>按Alt键取捕捉; Ctrl键启用正交; 退格键删除上一个点'
            html += `<br/>当前面积: <span style="color: #ff0000">${this.getArea(e.feature.coordinates[0])}</span>`
          }
          this.setPopupText(html)
        },
        contextMenu: (e) => {
          new vjmap.ContextMenu({
            event: e.event.originalEvent,
            theme: 'dark', // light
            width: '250px',
            items: [
              {
                label: '确认',
                onClick: () => {
                  // 给地图发送Enter键消息即可取消，模拟按Enter键
                  this._map.fire('keyup', { keyCode: 13 })
                  this.setPopupText('')
                }
              },
              {
                label: '取消',
                onClick: () => {
                  // 给地图发送ESC键消息即可取消，模拟按ESC键
                  this._map.fire('keyup', { keyCode: 27 })
                  this.setPopupText('')
                }
              }, {
                label: '删除上一个点',
                onClick: () => {
                  // 给地图发送退格键Backspace消息即可删除上一个点，模拟按Backspace键
                  this._map.fire('keyup', { keyCode: 8 })
                }
              }, {
                label: '结束测面积',
                onClick: () => {
                  // 给地图发送ESC键消息即可取消，模拟按ESC键
                  this._map.fire('keyup', { keyCode: 27 })
                  this.isDrawing = false
                  this.setPopupText('')
                }
              }
            ]
          })
        }
      })
      if (poly.cancel) {
        this.setPopupText('')
        return {
          cancel: true,
          exit: this.isDrawing === false // 如果还没有绘制，就取消的话，就结束测距
        }// 取消操作
      }

      const color = vjmap.randomColor()
      const polygon = new vjmap.Polygon({
        data: poly.features[0].geometry.coordinates[0],
        fillColor: color,
        fillOpacity: 0.4,
        fillOutlineColor: color
      })
      polygon.addTo(this._map)
      this.addMarkersToPolygon(poly.features[0].geometry.coordinates[0], color, polygon)
      return {
        polygon
      }
    },
    getArea (coordinates) {
      let result = vjmap.calcPolygonArea(this._map.fromLngLat(coordinates))
      let unit = 'm²'
      if (result >= 1e6) {
        result /= 1e6
        unit = 'km²'
      } else if (result < 1.0 / 1e4) {
        result *= 1e4
        unit = 'cm²'
      }
      return result.toFixed(2) + ' ' + unit
    },
    addMarkersToPolygon (coordinates, color, polygon) {
      let markerTexts = []
      const center = vjmap.polygonCentroid(this._map.fromLngLat(coordinates))
      const text = new vjmap.Text({
        text: this.getArea(coordinates),
        anchor: 'center',
        offset: [0, 0], // x,y 方向像素偏移量
        style: { // 自定义样式
          cursor: 'pointer',
          opacity: 0.8,
          padding: '6px',
          'border-radius': '12px',
          'background-color': `#${color.substr(1).split('').map(c => (15 - parseInt(c, 16)).toString(16)).join('')}`,
          'border-width': 0,
          'box-shadow': '0px 2px 6px 0px rgba(97,113,166,0.2)',
          'text-align': 'center',
          'font-size': '14px',
          color: color
        }
      })
      text.setLngLat(this._map.toLngLat(center)).addTo(this._map)
      markerTexts.push(text)
      // 给第一个点加一个marker用来删除
      const deletePng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAbNJREFUWEftlrFOAkEQhv9Z4XgJOCrlTgp5ABOhMBoTCws7EzUaeAx5A0sDiYmFxpLGaAkU2KqFArHi4CU4cMccAQN6HHcIwZi7cnd25tt/5maHsOCPFhwfPoAnBarhQFIIccjAkV3qCMhKKct6q1tym1pPAHVVOWMg6+ScgKuYYR7PBaCmKmw5XgLiy4b5NhzkXVVWP4BXa00zTNcXc21oOR4AjAswaX9M2n4u1yLBIoiSbmV0Zcdc0pqd1HdbWwUWDuDqRjMy8lQDM4o54sYRoJcKq6qHclePKnuScQ0pd/RWt2ztVyOhLUFckIwTvWneDiLYnXdVA18O+r/dcNXXIsozCGsMzuhGJ98DUINpAuUAqmhGe33k/JjiG9g4K2ADUFdDOQan7QAIlI8Z7YwP4CvgK/C/FahFlQcwtm0bEeNFa5qJuSpgdT2AzkFyU290H3udMBzYgBD3gnAQa5iFuQJ4eZB6A8ovW/ETgARLmfIyaPZVSZIQRTBdas326Thwx7fAzRA6SREB2l0x2ndTAfTnwH0CrGk4PinY6D5VQHyhNcwbp3N/eyDxduPprH0FPgHEyH4wGIHUYwAAAABJRU5ErkJggg=='
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.backgroundImage =
        `url(${deletePng})`
      el.style.width = '20px'
      el.style.height = '20px'
      el.style.backgroundSize = '100%'
      el.style.cursor = 'pointer'

      el.addEventListener('click', (e) => {
        this._map.removeSourceEx(polygon.sourceId) // 删除绘制的线
        markerTexts.forEach(m => m.remove())
        markerTexts = []
      })
      // Add markers to the map.
      const deleteMarker = new vjmap.Marker({
        element: el,
        anchor: 'right'
      })
      deleteMarker.setLngLat(coordinates[0])
        .setOffset([-5, 0])
        .addTo(this._map)
      markerTexts.push(deleteMarker)
      markerTexts.push(polygon)
      this._overlayers.push(...markerTexts)
    },
    async measureDistLoop () {
      while (true) {
        const res = await this.measureDist()
        if (res.exit === true) break
      }
    },
    async measureDist () {
      this.isDrawing = false
      const line = await vjmap.Draw.actionDrawLineSting(this._map, {
        api: {
          getSnapFeatures: {} // 要捕捉的数据项在后面，通过属性features赋值
        },
        updatecoordinate: (e) => {
          if (!e.lnglat) return
          this.isDrawing = true
          const co = this._map.fromLngLat(e.feature.coordinates[e.feature.coordinates.length - 1])
          let html = `当前坐标:<span style="color: #ff0000"> ${co.x.toFixed(2)}, ${co.y.toFixed(2)}</span>`
          if (e.feature.coordinates.length === 1) {
            html += '<br/>请指定要测量的第一点的坐标位置'
          } else {
            const len = e.feature.coordinates.length
            html += '<br/>按Alt键取捕捉; Ctrl键启用正交; 退格键删除上一个点'
            html += `<br/>距上一点距离: <span style="color: #ff0000">${this.getDist([e.feature.coordinates[len - 2], e.feature.coordinates[len - 1]])}</span>`
            html += `;  当前总的距离: <span style="color: #ff0000">${this.getDist(e.feature.coordinates)}</span>`
          }
          this.setPopupText(html)
        },
        contextMenu: (e) => {
          new vjmap.ContextMenu({
            event: e.event.originalEvent,
            theme: 'dark', // light
            width: '250px',
            items: [
              {
                label: '确认',
                onClick: () => {
                  // 给地图发送Enter键消息即可取消，模拟按Enter键
                  this._map.fire('keyup', { keyCode: 13 })
                  this.setPopupText('')
                }
              },
              {
                label: '取消',
                onClick: () => {
                  // 给地图发送ESC键消息即可取消，模拟按ESC键
                  this._map.fire('keyup', { keyCode: 27 })
                  this.setPopupText('')
                }
              }, {
                label: '删除上一个点',
                onClick: () => {
                  // 给地图发送退格键Backspace消息即可删除上一个点，模拟按Backspace键
                  this._map.fire('keyup', { keyCode: 8 })
                }
              }, {
                label: '结束测距',
                onClick: () => {
                  // 给地图发送ESC键消息即可取消，模拟按ESC键
                  this._map.fire('keyup', { keyCode: 27 })
                  this.isDrawing = false
                  this.setPopupText('')
                }
              }
            ]
          })
        }
      })
      if (line.cancel) {
        this.setPopupText('')
        return {
          cancel: true,
          exit: this.isDrawing === false // 如果还没有绘制，就取消的话，就结束测距
        }// 取消操作
      }

      const color = vjmap.randomColor()
      const polyline = new vjmap.Polyline({
        data: line.features[0].geometry.coordinates,
        lineColor: color,
        lineWidth: 2
      })
      polyline.addTo(this._map)
      this.addMarkersToLine(line.features[0].geometry.coordinates, color, polyline)
      return {
        polyline
      }
    },
    getDist (coordinates) {
      let result = vjmap.Math2D.lineDist(this._map.fromLngLat(coordinates))
      let unit = 'm'
      if (result >= 1000) {
        result /= 1000
        unit = 'km'
      } else if (result < 0.01) {
        result *= 100
        unit = 'cm'
      }
      return result.toFixed(2) + ' ' + unit
    },
    addMarkersToLine (coordinates, color, polyline) {
      let markerTexts = []
      for (let i = 1; i < coordinates.length; i++) {
        const text = new vjmap.Text({
          text: this.getDist(coordinates.slice(0, i + 1)),
          anchor: 'left',
          offset: [3, 0], // x,y 方向像素偏移量
          style: { // 自定义样式
            cursor: 'pointer',
            opacity: 0.8,
            padding: '6px',
            'border-radius': '12px',
            'background-color': color,
            'border-width': 0,
            'box-shadow': '0px 2px 6px 0px rgba(97,113,166,0.2)',
            'text-align': 'center',
            'font-size': '14px',
            color: `#${color.substr(1).split('').map(c => (15 - parseInt(c, 16)).toString(16)).join('')}`
          }
        })
        text.setLngLat(coordinates[i]).addTo(this._map)
        markerTexts.push(text)
      }
      // 给第一个点加一个marker用来删除
      const deletePng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAbNJREFUWEftlrFOAkEQhv9Z4XgJOCrlTgp5ABOhMBoTCws7EzUaeAx5A0sDiYmFxpLGaAkU2KqFArHi4CU4cMccAQN6HHcIwZi7cnd25tt/5maHsOCPFhwfPoAnBarhQFIIccjAkV3qCMhKKct6q1tym1pPAHVVOWMg6+ScgKuYYR7PBaCmKmw5XgLiy4b5NhzkXVVWP4BXa00zTNcXc21oOR4AjAswaX9M2n4u1yLBIoiSbmV0Zcdc0pqd1HdbWwUWDuDqRjMy8lQDM4o54sYRoJcKq6qHclePKnuScQ0pd/RWt2ztVyOhLUFckIwTvWneDiLYnXdVA18O+r/dcNXXIsozCGsMzuhGJ98DUINpAuUAqmhGe33k/JjiG9g4K2ADUFdDOQan7QAIlI8Z7YwP4CvgK/C/FahFlQcwtm0bEeNFa5qJuSpgdT2AzkFyU290H3udMBzYgBD3gnAQa5iFuQJ4eZB6A8ovW/ETgARLmfIyaPZVSZIQRTBdas326Thwx7fAzRA6SREB2l0x2ndTAfTnwH0CrGk4PinY6D5VQHyhNcwbp3N/eyDxduPprH0FPgHEyH4wGIHUYwAAAABJRU5ErkJggg=='
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.backgroundImage =
        `url(${deletePng})`
      el.style.width = '20px'
      el.style.height = '20px'
      el.style.backgroundSize = '100%'
      el.style.cursor = 'pointer'

      el.addEventListener('click', (e) => {
        this._map.removeSourceEx(polyline.sourceId) // 删除绘制的线
        markerTexts.forEach(m => m.remove())
        markerTexts = []

        // 多点了下，给地图发送退格键Backspace消息即可删除上一个点，模拟按Backspace键
        this._map.fire('keyup', { keyCode: 8 })
      })
      // Add markers to the map.
      const deleteMarker = new vjmap.Marker({
        element: el,
        anchor: 'right'
      })
      deleteMarker.setLngLat(coordinates[0])
        .setOffset([-5, 0])
        .addTo(this._map)
      markerTexts.push(polyline)
      markerTexts.push(deleteMarker)
      this._overlayers.push(...markerTexts)
    },
    async openMap (version) {
      const res = await this._svc.openMap({
        mapid: this.cadId, // 地图ID
        version: version || this.currentVersion,
        // mapopenway: vjmap.MapOpenWay.Memory, // 以几何数据渲染方式打开
        mapopenway: vjmap.MapOpenWay.GeomRender, // 以几何数据渲染方式打开
        style: vjmap.openMapDarkStyle() // div为深色背景颜色时，这里也传深色背景样式
      })
      if (res.error) {
        // 如果打开出错
        this.$message.error(res.error)
      }
      return res
    },
    async initService () {
      const svc = new vjmap.Service(vjEnv.serviceUrl, vjEnv.accessToken)
      this._svc = svc
      this._svc.switchWorkspace(vjEnv.workspace)
      await this.loadVersion()
    },
    async initMap (container, version) {
      // 打开地图
      const res = await this.openMap(version)
      // 获取地图范围
      const mapExtent = vjmap.GeoBounds.fromString(res.bounds)
      // 根据地图范围建立几何投影坐标系
      const prj = new vjmap.GeoProjection(mapExtent)

      const style = this._svc.vectorStyle({
        hoverColor: 'rgba(0,255,255,255)', // 自定义高亮时颜色
        hoverOpacity: 1, // 自定义 高亮时透明度
        hoverLineWidth: 4 // 自定义 高亮时线宽
      })
      // 地图对象
      const map = new vjmap.Map({
        container: container || 'map', // DIV容器ID
        style: style, // this._svc.rasterStyle(), // 样式，这里是栅格样式
        center: prj.toLngLat(mapExtent.center()), // 设置地图中心点
        zoom: 2, // 设置地图缩放级别
        pitchWithRotate: false,
        dragRotate: false,
        renderWorldCopies: false, // 不显示多屏地图
        doubleClickZoom: false // 禁用鼠标双击放大
      })

      if (container === 'map3') {
        this._map2 = map
      } else {
        this._map = map
      }

      // 关联服务对象和投影对象
      map.attach(this._svc, prj)
      // 根据地图本身范围缩放地图至全图显示
      map.fitMapBounds()

      map.on('contextmenu', e => {
        e.preventDefault()
      })

      if (this.activeIndex !== '6') {
        map.addControl(new vjmap.MiniMapControl({
          containerStyle: {
            background: '#31346a85',
            transform: 'scale(0.6)',
            transformOrigin: '0% 100%'
          }
        }), 'bottom-left')

        const scale = new vjmap.ScaleControl({
          maxWidth: 80,
          unit: 'metric'
        })
        map.addControl(scale, 'bottom-right')

        const mousePositionControl = new vjmap.MousePositionControl()
        map.addControl(mousePositionControl, 'bottom-right')
        await map.onLoad()

        const loadingInstance = this.$loading({ text: '加载中', background: 'rgba(0, 0, 0, 0.8)' })
        await this.initFeatures()
        loadingInstance.close()

        map.on('click', e => {
          if (!['0', '1'].includes(this.activeIndex)) {
            this.highlightEntity(null)
            this._popup && this._popup.remove()
            this.clearOverlayers()
          }
        })
      }

      // // 获取所有图层
      // const layers = this._svc.getMapLayers()
      // this.layers = layers
      // this.checkList = Array.from({ length: layers.length }, (_, index) => index)
    },
    async initFeatures () {
      const layers = this._svc.getMapLayers()
      const vStyle = await this._svc.createStyle({
        ...vjmap.openMapDarkStyle(),
        layeron: layers.map(item => item.index) // 要显示的图层，在矢量样式中，需要把道路图层显示了，其他的关闭
      })
      const query = await this._svc.conditionQueryFeature({
        // 过滤出类型为文本，颜色为黄色的
        condition: '1=1', // 只需要写sql语句where后面的条件内容,字段内容请参考文档"服务端条件查询和表达式查询"
        fields: 'id,objectid',
        layer: vStyle.stylename,
        limit: 10000000 // 设置很大，相当于把所有的圆都查出来。不传的话，默认只能取100条
      })
      for (let i = 0; i < query.result.length; i++) {
        const item = query.result[i]
        this.featureIdObjectIdMap[item.id] = item.objectid
        const entityId = this.getEntityObjectId(item.objectid) // 获取整个实体的id
        const ids = this.entityIdFeatureIdMap[entityId]
        if (ids === undefined) {
          this.entityIdFeatureIdMap[entityId] = new Set()
        }
        this.entityIdFeatureIdMap[entityId].add(item.id)
      }

      const query2 = await this._svc.exprQueryFeature({
        expr: 'gOutReturn := if((gInFeatureType != \'AcDb3dSolid\'), 1, 0);',
        geom: false,
        useCache: true,
        fields: 'objectid,blockname,layername,isclosed,area',
        layer: vStyle.stylename,
        limit: 100000
      })
      this._entitys = new Map(query2.result.map(item => {
        return [item.objectid, item]
      }))
    },
    resetSelection () {
      this.activeIndex = ''
      this.isDrawing = false
      this.highlightEntity(null) // 取消高亮
      this.clearOverlayers()
      this.setPopupText('') // 关闭弹框
      this._map.fire('keyup', { keyCode: 27 })
      this._map.setMenu() // 关闭右键菜单
      this._cancelSyncCb && this._cancelSyncCb() // 清空同步事件
      this._map.disableLayerClickHighlight() // 禁用点击高亮
    },
    async clickHighlight () {
      this._map.enableLayerClickHighlight(this._svc, e => {
        if (!e) {
          return
        }
        const id = e.id
        this.loadFeatureInfo(id)
        this.highlightEntity(id)
      }, '#0000', '', '', lnglat => {
        this._currentLngLat = lnglat
      } /* 不绘制，只响应点击事件 */)
      this._map.setMenu(event => {
        return new vjmap.ContextMenu({
          event: event.originalEvent,
          theme: 'dark',
          width: '150px',
          items: [
            {
              label: '结束点选',
              onClick: this.resetSelection
            }
          ]
        })
      })
    },
    async loadFeatureInfo (id) {
      const objectId = this.featureIdObjectIdMap[id]
      const entityId = this.getEntityObjectId(objectId) // 获取整个实体的id
      const current = {
        type: '',
        title: ''
      }
      const data = this._entitys.get(entityId)
      current.title = data.layername
      if (data.blockname) { // 实体
        current.type = '1'
        current.objectName = data.blockname || '未知'
      } else {
        if (data.isclosed === 1 && data.area > 0) { // 面积
          current.type = '2'
          current.area = data.area.toFixed(2)
        } else { // 非面积
          current.type = '3'
        }
      }
      this.popupData = current
      this._popup = new vjmap.Popup({
        className: 'measure-popup',
        closeOnClick: false,
        closeButton: false
      }).setDOMContent(this.$refs.popup)
        .setLngLat(this._currentLngLat)
        .addTo(this._map)
    },
    changeFeatureStatus (ids, state) {
      if (!ids) return
      const sourceLayers = ['polygons', 'lines', 'points']
      // vector source下面的所有图层
      for (const sourceLayer of sourceLayers) {
        // 块下面的所有feature id
        for (const id of ids) {
          this._map.setFeatureState({
            source: 'vector-source',
            sourceLayer: sourceLayer,
            id: id
          },
          state)
        }
      }
    },
    highlightEntity (featureId) {
      if (this.curHoverIds) {
        this.changeFeatureStatus(this.curHoverIds, { hover: false })
        this.curHoverIds = null
      }
      // hover高亮实体回调事件
      if (featureId === null) {
        return
      }
      const id = featureId
      const objectId = this.featureIdObjectIdMap[id]
      const entityId = this.getEntityObjectId(objectId) // 获取整个实体的id
      // 获取同一个实体其他的feature id
      const ids = this.entityIdFeatureIdMap[entityId]
      if (ids.size > 0) {
        this.changeFeatureStatus(ids, { hover: true })
        this.curHoverIds = ids
      }
      const content = `entityId: ${entityId}`
      this.$message.info({ content, key: 'info', duration: 5 })
    },
    highlightEntitys (ids) {
      if (this.curHoverIds) {
        this.changeFeatureStatus(this.curHoverIds, { hover: false })
        this.curHoverIds = null
      }
      if (ids.size > 0) {
        this.changeFeatureStatus(ids, { hover: true })
        this.curHoverIds = ids
      }
    },
    getEntityObjectId (id) {
      // id如 A0F$A10 或 380#26F&26C 这种格式，只要前面的一部分就是cad的实体objectid
      let objectId = ''
      let k = 0
      // 判断一个字符是英文字符或数字
      const isAlphanumeric = (char) => {
        return /^[a-zA-Z0-9]+$/.test(char)
      }
      for (k = 0; k < id.length; k++) {
        if (isAlphanumeric(id[k])) {
          objectId += id[k]
        } else {
          break
        }
      }
      return objectId
    },
    // 关闭
    closeDialog () {
      this.dialogVisible = false
    },
    drawDiffPolygons (map, points, color) {
      if (points.length === 0) return
      points.forEach(p => p.push(p[0])) // 闭合
      const polygons = points.map(p => {
        return {
          points: map.toLngLat(p),
          properties: {
            color: color
          }
        }
      })
      const animateLayer = vjmap.createAntPathAnimateLineLayer(map, polygons, {
        fillColor1: color,
        fillColor2: '#0ffb',
        canvasWidth: 128,
        canvasHeight: 32,
        frameCount: 4,
        lineWidth: 4,
        lineOpacity: 0.8
      })
      this._overlayers.push(animateLayer)
    },
    async compareDiff () {
      this._cancelSyncCb = vjmap.syncMaps(this._map, this._map2)
      const diff = await this._svc.cmdMapDiff({
        // 要比较图1的图名称
        mapid1: this.cadId,
        // 要比较图1的图版本，如为空，表示是最新版本
        version1: this.currentVersion,
        // 要比较图1的图层样式名称，可为空。为空的用默认的
        layer1: null,
        // 要比较图2的图名称，图名称可以和mapid1不一样
        mapid2: this.cadId,
        // 要比较图2的图版本，如为空，表示是最新版本
        version2: this.otherVersion,
        // 要比较图2的图层样式名称，可为空。为空的用默认的
        layer2: null
      })

      if (diff.error) {
        console.log('比对失败', diff.error)
        this.$message.error('比对失败，无共同区域')
        return
      }
      if (this.activeIndex === '6') {
        // 修改的部分
        this.drawDiffPolygons(this._map2, diff.modify, '#f00')
        // 新增部分
        this.drawDiffPolygons(this._map2, diff.new, '#0f0')
        // 删除部分
        this.drawDiffPolygons(this._map, diff.del, '#00f')
      }
    },
    showDiffDialog () {
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss">
.vjmapgis-ctrl-bottom-right {
  display: flex;
  align-items: center;
}

.vjmapgis-popup-content {
  .zhitu-popup {
    display: flex !important;
  }
}
</style>
<style scoped lang="scss">
.map-content {
  height: 100%;
  position: relative;
}

.kuang-popup {
  position: absolute;
  left: 90px;
  top: 260px;
  width: 94px;
  height: 70px;
  background: #FDFFFE;
  box-shadow: 0px 5px 16px 0px rgba(60, 60, 60, 0.96);
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 10;
  user-select: none;

  .item {
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 20px;
    flex: 1;

    &:hover {
      background: #CCDFFF;
    }

    &.active {
      &:before {
        content: '';
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translate3d(0, -50%, 0);
        width: 4px;
        height: 4px;
        background: #000000;
      }
    }

    .label {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #000000;
      margin-left: 6px;
    }
  }
}

.zhitu-popup {
  min-width: 160px;
  background: #FFFFFF;
  padding: 0 10px;
  box-shadow: 0px 5px 16px 0px rgba(186, 186, 186, 0.96);
  border-radius: 6px;
  display: none;
  flex-direction: column;

  .header {
    height: 46px;
    display: flex;
    align-items: center;
    padding: 0 10px;

    &.center {
      justify-content: center;
    }

    span {
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #000000;
    }
  }

  .info {
    width: 260px;
    height: 36px;
    background: #F6F6F6;
    border-radius: 4px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    span {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #000000;
    }

    &.center {
      justify-content: center
    }
  }

  .table {
    margin-bottom: 15px;
    width: 238px;
    max-height: 450px;
    overflow-y: auto;

    table {
      border-collapse: collapse;
      width: 100%;

      thead {
        th {
          background: #F5F5F5;

          &:nth-child(1) {
            width: 150px;
          }
        }
      }

      th,
      td {
        border: 1px solid #E2E2E2;
        /* 细边框 */
        height: 30px;
        line-height: 30px;
        text-align: left;
        padding-left: 10px;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #000000;
      }
    }
  }
}

.map {
  background: #000000;
  height: 100%;

  &.diff {
    display: flex;

    .item {
      flex: 1;

      &:nth-child(2) {
        border-left: 1px solid #ffffff;
      }
    }
  }
}

.version-list {
  position: absolute;
  top: 20px;
  left: 110px;
  width: 150px;
  height: 50px;
  background: #FFFFFF;
  box-shadow: 0px 5px 10px 0px rgba(186, 186, 186, 0.7);
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 0 10px 0 15px;
  cursor: pointer;

  &.other {
    left: 50%;
    transform: translate3d(20px, 0, 0);
  }

  &.diff {
    left: auto;
    right: 20px;
  }

  .el-dropdown {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .label {
    width: 100px;
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 12px;
    color: #1B85FF;
    line-height: 50px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .iconfont {
    font-size: 16px;
    color: #1B85FF;
    opacity: 0.69;
  }
}

.tools {
  position: absolute;
  top: 160px;
  left: 20px;
  display: flex;
  flex-direction: column;
  width: 70px;
  height: 417px;
  background: #FFFFFF;
  box-shadow: 0px 5px 16px 0px rgba(60, 60, 60, 0.96);
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  user-select: none;
  padding: 12px 0;

  .tool-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    justify-content: center;
    cursor: pointer;
    border-radius: 4px;
    width: 100%;

    &:nth-child(n + 2) {
      &:not(.active) {
        &:before {
          content: '';
          position: absolute;
          width: 1px;
          height: 33px;
          background: #D9D9D9;
          left: 0;
          top: 8px;
          transform: scaleX(0.5);
        }
      }
    }

    &.active {

      .label {
        color: #006FFF;
      }

      .iconfont {
        color: #006FFF;
      }
    }

    .label {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: var(--cad-tools-text-color);
      margin-top: 6px;
    }

    .iconfont {
      color: var(--cad-tools-icon-color);
      font-size: 20px;
    }
  }
}

.layers {
  position: absolute;
  bottom: 100px;
  right: 10px;
  min-width: 184px;
  background: #ECECEC;
  box-shadow: 0px 5px 16px 0px rgba(186, 186, 186, 0.96);
  border-radius: 10px;
  padding: 10px;
  max-height: 500px;
  overflow-y: auto;
}

.back {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 70px;
  height: 50px;
  background: var(--cad-tools-background-color);
  box-shadow: 0px 5px 16px 0px rgba(186, 186, 186, 0.96);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 10px;
  cursor: pointer;

  .iconfont {
    font-size: 26px;
    color: var(--cad-tools-text-color);
  }

  .label {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: var(--cad-tools-text-color);
    margin-left: -4px;
  }
}
</style>
